<script setup lang="ts">
import type { NuxtError } from '#app';

defineProps({
  error: Object as () => NuxtError,
});
// NOTE: don't use NuxtLayout as  it was returning a 500 error for “cannot access locale”
</script>

<template>
  <div>
    <MainHeader />
    <IadPlaceholderError :status-code="error?.statusCode" />
    <ClientOnly>
      <MainFooter />
    </ClientOnly>
  </div>
</template>
